import { FC } from 'react';

import { IonProgressBar } from '@ionic/react';
import classNames from 'classnames';

import styles from './ContentProgress.module.scss';

interface ContentProgressProps {
  value: number;
  className?: string;
}

export const ContentProgress: FC<ContentProgressProps> = ({
  value = 0,
  className,
}) => {
  return (
    <IonProgressBar
      value={value}
      className={classNames(className, styles.root)}
    />
  );
};
